// PhotoUploadForm.js
import React, { useEffect, useState } from "react";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import { formatUpdateDate } from "../../utils/utils";

export const PhotoUploadForm = ({
  selectedEtablissement,
  photos = [],
  maxFiles = 10,
  maxSizeMB = 2,
  allowedFormats = ["image/jpeg", "image/png"],
  onFileChange,
  onDelete,
  onDragEnd,
  error = "",
  handleSubmit,
  from,
  isLoading
}) => {
  // console.log({photos})
  const [isExpanded, setIsExpanded] = useState(from==="account"  ?false:true);
    const [isCompleted, setIsCompleted] = useState(true); // Add this state
  useEffect(()=>{

    setIsCompleted(photos?.length>0)
  },[photos,isLoading])
  useEffect(() => {
    // console.log("📷 Photos reçues du parent :", photos);
  }, [photos]); 
  return (
    <div className="">
      <div className="">
        <div className="d-flex flex-wrap justify-content-between align-items-center">
          {from === "account" ? (
            <h4 className="grey500">
              Photos de votre établissement
              <button
                type="button"
                className="btn btn-link p-0"
                onClick={() => setIsExpanded(!isExpanded)}
              >
                <img
                  src={
                    isExpanded
                      ? "/images/chevron-down.svg"
                      : "/images/chevron-down.svg"
                  }
                  className={`w-6 h-6 ${!isExpanded ? "rotate180" : ""}`}
                  alt={isExpanded ? "Réduire" : "Ouvrir"}
                />
            {!isCompleted && selectedEtablissement ? <img src="/images/notCompleted.svg" alt="not completed icon" className="ml-8" />:''}

              </button>
            </h4>
          ) : (
            <h3 className="grey500">Photos de votre établissement</h3>
          )}
          {from === "account" && (
            <div className="d-flex align-items-center">
              {selectedEtablissement?.updated_at && (
                <span className="body grey66 mr-16">
                  Dernière mise à jour:{" "}
                  {formatUpdateDate(selectedEtablissement.updated_at)}
                </span>
              )}
            </div>
          )}
        </div>
        {isExpanded && (
          <>
            <p className="body mt-32 grey500 bold500">
              Photo(s){" "}
              <span className="legend grey66">
                {photos.length}/{maxFiles} max
              </span>
            </p>

            <label
              htmlFor="file-upload"
              className="import-photos custom-dashed mt-8"
            >
              <img src="/images/download-02.svg" alt="download icon" />
              <p className="body bold500 primary text-center mt-8 mb-0">
                Ajouter vos photos
              </p>
            </label>
            <input
              id="file-upload"
              type="file"
              multiple
              accept={allowedFormats.join(", ")}
              className="d-none"
              onChange={onFileChange}
            />
            <p className="mt-8 legend grey66">
            Taille maximale et optimale 1920 x 1080; Formats autorisés :{" "}
              {allowedFormats.map((f) => f.split("/")[1]).join(", ")}; Poids
              maximal : {maxSizeMB}Mo
            </p>
            {error && <p className="text-danger mt-2">{error}</p>}

            <DragDropContext onDragEnd={onDragEnd}>
              <Droppable droppableId="photos">
                {(provided) => (
                  <ul
                    className="file-list mt-24"
                    {...provided.droppableProps}
                    ref={provided.innerRef}
                  >
                    {photos.map((photo, index) => (
                      <Draggable
                        key={String(photo.id)}
                        draggableId={String(photo.id)}
                        index={index}
                      >
                        {(provided) => (
                          <li
                            ref={provided.innerRef}
                            {...provided.draggableProps}
                            className="file-item badge-pre"
                          >
                            <span
                              className="drag-handle"
                              {...provided.dragHandleProps}
                            >
                              <img src="/images/drag.svg" alt="drag icon" />
                            </span>
                            <img
                              src={
                                photo?.url_photo
                                  ? `${process.env.REACT_APP_FILE_URL}${photo?.url_photo}`
                                  : photo.preview
                              }
                              alt={photo.name}
                              className="establishment-image"
                            />
                            <span className="file-name body grey500">
                              {photo.name} (Order: {photo.order || photo?.sort})
                            </span>
                            <span
                              className="delete-icon"
                              onClick={() => onDelete(photo)}
                            >
                              <img src="/images/trash.svg" alt="trash icon" />
                            </span>
                          </li>
                        )}
                      </Draggable>
                    ))}
                    {provided.placeholder}
                  </ul>
                )}
              </Droppable>
            </DragDropContext>
            {from === "account" ? (
              <button
                type="submit"
                onClick={handleSubmit}
                className="twyny-cta-primary w-100"
              >
                Enregistrer les modifications
              </button>
            ) : (
              ""
            )}
          </>
        )}
      </div>
    </div>
  );
};
